import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import globalStyles from '../../global';
import { getResponsiveHeight, getResponsiveSize } from '../../utils/responsive';
import BroucherForm from './BroucherForm';

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <Box sx={styles.box1}>
      <Box
        sx={{
          ...styles.box2,
          width: isMobile ? '90%' : isTablet ? '80%' : '62%',
        }}
      >
        <Box
          sx={[
            styles.typography,
            {
              fontSize: {
                xs: getResponsiveSize(40 * 0.7),
                md: getResponsiveSize(40 * 0.8),
                lg: getResponsiveSize(40),
              },
            },
          ]}
        >
          DOWNLOAD FRANCHISE BROCHURE
        </Box>
        <Box
          sx={[
            styles.text1,
            {
              fontSize: {
                xs: getResponsiveSize(18 * 0.7),
                md: getResponsiveSize(18 * 0.8),
                lg: getResponsiveSize(18),
              },
            },
          ]}
        >
          Ready to learn more? Get all the details about UClean's franchise
          opportunity. Fill the form to download our Franchise Brochure and take
          the first step towards owning a UClean outlet.
        </Box>
        <BroucherForm />
      </Box>
    </Box>
  );
};
const styles = {
  box1: {
    backgroundColor: globalStyles.colors.army_green,
    width: '100%',
    paddingBottom: getResponsiveHeight(8),
  },
  box2: {
    // width: '62%', Removed to be handled by media queries
    margin: 'auto',
    paddingTop: getResponsiveSize(10),
  },
  typography: {
    color: globalStyles.colors.white,
    fontSize: getResponsiveSize(45),
    fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    lineHeight: 1.2,
    textAlign: 'center',
    '@media (max-width:600px)': {
      fontSize: getResponsiveSize(32),
    },
  },
  text1: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    fontSize: getResponsiveSize(18),
    color: globalStyles.colors.white,
    textAlign: 'center',
    padding: getResponsiveSize(2),
    '@media (max-width:600px)': {
      fontSize: getResponsiveSize(16),
    },
  },
};
export default Header;
